import { useIntl } from '@leagueplatform/locales';
import type { Link } from 'common/types';
import { createLink } from 'utils/navigation-links.utils';
import { usePaymentLinkVisibility } from './use-payment-link-visibility.hook';

export function useAccountSettingLinks(): Link[] {
  const { formatMessage } = useIntl();
  const {
    showMedicarePremium,
    showSupplementalAutoPay,
    showPDPPremium,
    showManagePharmacySettings,
  } = usePaymentLinkVisibility();

  const links: Link[] = [createLink('personalInfo', formatMessage)];

  if (showManagePharmacySettings) {
    links.push(createLink('managePharmacySettings', formatMessage));
  }

  if (showMedicarePremium) {
    links.push(createLink('medicarePremium', formatMessage));
  }

  if (showSupplementalAutoPay) {
    links.push(createLink('supplementalPremium', formatMessage));
  }

  if (showPDPPremium) {
    links.push(createLink('pdpPremium', formatMessage));
  }

  links.push(createLink('securitySettings', formatMessage));

  return links;
}
